import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { globalState } from 'helpers/store';

export default function ColumnBox(props) {
    const nState = globalState.notification.state;
    const setNState = globalState.notification.setState;
    const handleClose = (event, reason) => {
        setNState({ ...nState, open: false })
    }
    return (
        <Snackbar
            open={nState.open || false}
            autoHideDuration={nState.duration || 4000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            sx={{
                position: 'fixed',
                bottom: '140px',
                left: 0,
                right: 0,
                margin: '0 auto',
                width: 'min(500px, 90vw)',
                zIndex: 9999,
                '&.MuiSnackbar-root': {
                    position: 'fixed',
                    bottom: '140px',
                    left: 0,
                    right: 0,
                    margin: '0 auto',
                    zIndex: 9999,
                    width: 'min(500px, 90vw)',
                },
            }}
        >
            <Alert severity={nState.severity || "info"} sx={{ width: '100%', minWidth: 0, fontSize: '1rem', padding: '12px 16px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                {nState.title && <AlertTitle>{ nState.title || '' }</AlertTitle>}
                { nState.description || '' }
            </Alert>
        </Snackbar>
    )
}
